import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged, startWith, takeUntil } from 'rxjs';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'app-missing-law-firms-filter',
  templateUrl: './missing-law-firms-filter.component.html',
  styleUrls: ['./missing-law-firms-filter.component.scss'],
  imports: [MatRadioGroup, FormsModule, ReactiveFormsModule, MatRadioButton],
})
export class MissingLawFirmsFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly law_firm_missing = new FormControl<0 | 1 | null>(null);

  ngOnInit(): void {
    this.payeeCasesService.law_firm_missing
      .pipe(
        startWith(this.payeeCasesService.law_firm_missing.value),
        takeUntil(this.destroy),
        distinctUntilChanged(),
      )
      .subscribe((v) =>
        this.law_firm_missing.patchValue(v, { emitEvent: false }),
      );

    this.law_firm_missing.valueChanges
      .pipe(takeUntil(this.destroy), distinctUntilChanged())
      .subscribe((v) => this.payeeCasesService.law_firm_missing.next(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
